$(document).ready(function(){
	$(".generalmessage").prependTo(".header");
		//prepend general message into header
		if ( $("body").hasClass("generalMessageOn") ) {
			$(".generalmessage").prependTo(".header");
		}

			// Remove button class from footer menu
		$( ".footerItems1 a" ).removeClass( "button" );
	// footer logo
		$('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
	// Remove button class from footer menu
	$( ".footerItems1 a" ).removeClass( "button" );
	if ($(window).width() < 801) {
		$('#siteInfoBannerWidget').appendTo('.bottom-header');
	} else {
			 $('#siteInfoBannerWidget').prependTo('.top-header .container');
	}
});


$(window).resize(function(){
	// Remove button class from footer menu
	$( ".footerItems1 a" ).removeClass( "button" );
	if ($(window).width() < 801) {
		$('#siteInfoBannerWidget').appendTo('.bottom-header');
	} else {
			 $('#siteInfoBannerWidget').prependTo('.top-header .container');
	}

});
